<template>
  <Html :lang="htmlAttrs.lang" :dir="htmlAttrs.dir">

  <Body>
    <div class="min-h-screen bg-white">

      <div id="body-content"></div>
      <Header />
      <div class="h-[70px]"></div>
      <VSnackBarToast />

      <!-- Products dropdown - hidden on mobile -->
      <div class="hidden md:block">
        <div class="products-dropdown print:hidden shadow-md my-2 bg-white border-y border-gray-100 w-full"
          v-if="productsMenu.length">
          <div class="grid grid-cols-12 gap-4 px-4">
            <div class="col-start-1 col-span-12 !flex !flex-row !flex-nowrap items-center">
              <div class="cat-tree p-2 !shrink-0">
                <CategoryCategoryTree />
              </div>
              <div
                class="all-items all-items-deals green-nav-height flex flex-1 flex-wrap justify-center items-center gap-2 p-2">
                <div class="catagory-items-sub-info catagory-item-sub" v-for="pm in productsMenu" :key="pm.key">
                  <p v-if="!privateProductsMenus[pm.key] || (privateProductsMenus[pm.key] && isAuthenticated)"
                    class="catagory-text flex items-center cursor-pointer px-4 py-2 rounded-md hover:bg-gray-50 text-gray-700 hover:text-primary transition-all duration-200"
                    @click="addFilter(pm)">
                    <img :src="image(pm.img, { height: 20 })"
                      class="w-5 h-5 mr-2 object-contain grayscale group-hover:grayscale-0" alt="icon" />
                    <span class="font-semibold uppercase tracking-wide text-xs">{{ $t(`menu.${pm.key}`) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <NuxtPage />

      <!-- Scroll to top button -->
      <ClientOnly>
        <div
          class="fixed bottom-4 right-4 w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-primary/90 transition-colors print:hidden z-50"
          v-scroll-to="'#body-content'">
          <i class="fa fa-angle-double-up"></i>
        </div>
      </ClientOnly>

      <LazyFooter />

    </div>
  </Body>

  </Html>
</template>

<script setup>

import { getQuery, parseURL } from "ufo";

import { useCategoryStore } from "~/store/CategoryStore";
import { useUtilityStore } from "~/store/UtililityStore";
import { useCmsStore } from "~/store/cms/cmsStore";
import { productsMenu, privateProductsMenus } from "~/composables/data";
import { useFilterStore } from "~/store/FilterStore";
import { useUserStore } from "~/store/UserStore";
import { useI18n } from "vue-i18n";
import CategoryCategoryTree from '../components/Category/TreeNavigation.vue';
import { useOrderStore } from "~/store/OrderStore";
// import { useOrderStore } from "~/store/OrderStore";


const { t, locale } = useI18n();
const head = useLocaleHead({
  addDirAttribute: true,      // Adds dir
  addSeoAttributes: true,     // Adds lang
})
const router = useRouter();
const route = useRoute();
const localePath = useLocalePath();
const htmlAttrs = computed(() => head.value.htmlAttrs)
useHead({
  title: t('seo.title'),// "CLD Distribution - Leading European Distributor and Wholesaler in Entertainment and Pop-Culture ",
  meta: [{ name: "description", content: t('cld_desc1') }],
  link: head.value.link,
  htmlAttrs: head.value.htmlAttrs,
});


const image = useImage()
const cmsStore = useCmsStore();
const categoryStore = useCategoryStore();
const utilityStore = useUtilityStore();
const userStore = useUserStore();
const filterStore = useFilterStore();
const orderStore = useOrderStore();

// const parentCategories = computed(() => categoryStore.parentCategories);
// const imgUrl = (url) => cmsStore.getImageUrl(url);
// const selectedLanguage = computed(() => utilityStore.selectedLanguage);
// const parentCategoriesObj = computed(() => categoryStore.parentCategoriesObj);


const isAuthenticated = computed(() => userStore.isAuthenticated);


const addFilter = async (v) => {
  const rawPath = typeof v?.path === "string" ? v.path : "/products/search";
  const { pathname } = parseURL(rawPath);
  const query = getQuery(rawPath);

  const targetPath = localePath(pathname || "/products/search");
  const isOnSearchPage = route.path === targetPath;

  // First redirect (only if needed)
  if (!isOnSearchPage) {
    await router.push({ path: targetPath, query });
  } else {
    // Same page: just update query without a full navigation history entry
    await router.replace({ path: targetPath, query });
  }


}

// const getCategoryLabel = computed(() => {
//   return (labels) => labels.Labels[selectedLanguage.value] || labels.Labels['en_GB']

// })
onBeforeMount(() => {
  setTimeout(() => {
    categoryStore.getParentCategories();
    cmsStore.getLicense();
    cmsStore.getCoverSliders();
    // cmsStore.getCmsCategory();
  }, 0);
});

onMounted(() => {
  setTimeout(() => {
    orderStore.getAccountingSituationLocalStorage()
  }, 2000);
})


</script>
<style>
/* Keep minimal legacy styles for products dropdown */
.catagory-items-sub-info {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 2px solid transparent;
  gap: 0.25rem;
}

.catagory-text {
  margin-top: 0;
  cursor: pointer;
}

/* Spinner animation for loading states */
.spinner {
  width: 50px;
  height: 2.5rem;
  text-align: center;
  font-size: 10px;
}

.spinner>div {
  background-color: var(--color-primary);
  height: 100%;
  width: 0.375rem;
  display: inline-block;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  animation-delay: -1.1s;
}

.spinner .rect3 {
  animation-delay: -1s;
}

.spinner .rect4 {
  animation-delay: -0.9s;
}

.spinner .rect5 {
  animation-delay: -0.8s;
}

@keyframes sk-stretchdelay {

  0%,
  40%,
  100% {
    transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1);
  }
}
</style>
